import { render, staticRenderFns } from "./DocumentDeleteDialog.vue?vue&type=template&id=76d2275f"
import script from "./DocumentDeleteDialog.vue?vue&type=script&lang=js"
export * from "./DocumentDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentDeleteDialog.vue?vue&type=style&index=0&id=76d2275f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports